"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TextArea extends _react.Component {
  state = {
    validationState: null
  };
  componentDidMount() {
    this._textarea.addEventListener('invalid', this._onInvalid);
  }
  componentWillUnmount() {
    this._textarea.removeEventListener('invalid', this._onInvalid);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onInvalid
    } = this.props;
    const validationState = evt.currentTarget.validity;
    this.setState({
      validationState
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  _onChange = evt => {
    const {
      onChange
    } = this.props;
    this.setState({
      validationState: null
    });
    if (onChange) {
      onChange(evt);
    }
  };
  render() {
    const {
      className,
      name,
      label,
      placeholder,
      disabled,
      required,
      autoFocus,
      helpNode,
      error,
      defaultValue,
      maxLength,
      icon
    } = this.props;
    const {
      validationState
    } = this.state;
    const isValid = validationState ? validationState.isValid : true;
    const classes = (0, _classnames.default)('TextArea', 'FormElement', {
      'TextArea-with-icon': icon
    }, {
      'FormElement-contains-error': !isValid
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control-container"
    }, label, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control"
    }, /*#__PURE__*/_react.default.createElement("textarea", {
      ref: node => {
        this._textarea = node;
      },
      className: "FormElement-item",
      name: name,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      autoFocus: autoFocus,
      maxLength: maxLength,
      defaultValue: defaultValue,
      onChange: this._onChange
    }), icon)), helpNode && /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-help-text"
    }, helpNode), !isValid && error);
  }
}
exports.default = TextArea;